import { TrackingProxy } from './tracking-proxy';
import { distinctUntilChanged, map, debounceTime } from 'rxjs/operators';
import globals from '../../globals';
//import { getTarget } from '../../utils/get-target';
import { debug } from '../../utils/debug-log';


export class OmnitureTracking extends TrackingProxy {
    constructor(settings = {}, amp) {
        super(settings, amp);
        this.state.isMuted = amp.config.muted;
        debug.log("[OmnitureTracking] Constructor:", settings);
    }
    destroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        })
    }
    init() {
        debug.log("[OmnitureTracking] init()");
        this.initAppMeasurementContext();
        this.trackingEvents.forEach(eventName => {
            let source$ = null;
            if (eventName === 'timeupdate') {
                source$ = this.amp.AmpEventsSources[eventName].pipe(
                    map(data => {
                        //let { amp } = data;
                        let { currentTime, duration } = data.state;
                        let timePercent = (currentTime / duration) * 100;
                        data.state.timePercent = timePercent;
                        return data;
                    }),
                    distinctUntilChanged(null, data => {
                        return data.state.timePercent;
                    }))
            } else if (eventName === 'volumechange') {
                source$ = this.amp.AmpEventsSources[eventName].pipe(
                    debounceTime(100))
            } else if (eventName === 'fullscreenchange') {
                source$ = this.amp.AmpEventsSources[eventName].pipe(
                    distinctUntilChanged((prevData, currData) => {
                        return prevData.state.isFullscreen === currData.state.isFullscreen
                    })
                );
            } else {
                source$ = this.amp.AmpEventsSources[eventName];
            }
            if (source$ != null) {
                let subscription = source$.subscribe(data => {
                    try {
                        if (this.allowEvents[eventName].disable === false) {
                            this[`on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`](data)
                        } else if (this.allowEvents[eventName].disableOnce === true) {
                            this.allowEvents[eventName].disable = false;
                        }
                    } catch (e) {
                        debug.warn("[Omniture Tracking] ", eventName, ":", e)
                    }
                })
                this.subscriptions.push(subscription);
            }
        })
    }
    initAppMeasurementContext() {
        const {
            sfNumber,
            brandId,
            brandName,
            productId,
            productName,
            activityId,
            toolin,
            actid
        } = this.settings;
        let { title } = this.amp.media;
        const { videoId } = this.amp.media.metadata;
        const { wmdSetContext, s_sptr, s_sprodid, s_sprod, s_sactid, s_sact } = globals;
        const sprodid = s_sprodid || productId;
        const sprod = s_sprod || productName;
        const sactid = s_sactid || activityId;
        const sact = s_sact || sfNumber;
        let sptr = s_sptr || brandName;
        if (s_sptr == null && brandName != null && brandId != null && brandId !== "") {
            sptr += ` [ ${brandId} ]`;
        }
        let titleEl = document.createElement('div');
        titleEl.innerHTML = title;
        title = titleEl.textContent;


        wmdSetContext('wb.sptr', sptr);
        wmdSetContext('wb.sact', `${sact}`);
        wmdSetContext('wb.sprod', sprod);
        wmdSetContext('wb.sprodid', sprodid);

        if (sactid != null) {
            wmdSetContext('wb.sactid', sactid);
        }
        if(actid != null) {
            wmdSetContext('wb.actid', actid);
        }
        this.videoTrackingObject = {
            'wb.toolin': toolin || `video-svp`,
            'wb.vdname': title || '',
            'wb.vdnameid': videoId || ''
        };
    }

    onAutoplayblocked(eventData) {
        debug.warn("[OmnitureTracking] EVENT - Autoplay Blocked:", eventData);
        this.allowEvents["mutechange"] = {
            disable: true,
            disableOnce: true
        }
        this.allowEvents["volumechange"] = {
            disable: true,
            disableOnce: true
        }
    }
    onBufferingchange(eventData) {
        this.state.buffering = eventData.event.detail;
    }
    onCc_visibilitychange(eventData) {
        let mlink = eventData.state.isCcVisible ? "ccy" : "ccn";
        this.track({
            mmodule: `${this.moduleName}-ctl`,
            mlink: mlink,
            eventData
        });
    }
    onEnded(eventData) {
        this.trackMilestone(100, eventData);
        this.state.ended = true;
        this.state.started = false;
        this.state.play = false;
        this.state.hasStartedPlaying = false;

    }
    onFullscreenchange(eventData) {
        const mlink0 = eventData.state.isFullscreen ? 'bigr' : 'smalr';
        this.track({
            mmodule: `${this.moduleName}-ctl`,
            mlink: mlink0,
            eventData
        });
    }
    onLoadeddata(eventData) {
        debug.log("[OmnitureTracking] loadeddata:", eventData);

        this.state.loadeddata = true;
        this.state.hasStartedPlaying = false;
    }

    onPause(eventData) {

        let { amp } = eventData;
        // Prevent tracking after video ends and when seeking
        if (this.milestones["100"] === true && amp.seeking === false) {
            this.track({
                mmodule: `${this.moduleName}-ctl`,
                mlink: 'pause',
                eventData
            })
        }
        this.state.play = false;
    }
    onPlay(eventData, flag = 'ctl') {
        let { amp } = eventData;
        debug.log("[OmnitureTracking] onPlay wasAutoplayed:", this.state.wasAutoplayed);
        if (this.state.wasAutoplayed === false && amp.media.autoplay === true) {
            flag = 'ato';
            this.state.wasAutoplayed = true;
        }
        debug.log("[OmnitureTracking] onPlay flag:", flag);
        debug.log("[OmnitureTracking] onPlay state.wasAutoplayed:", this.state.wasAutoplayed);
        if (!this.state.started) {
            this.onStarted(eventData);
        }
        this.track({
            mmodule: `${this.moduleName}-${flag}`,
            mlink: 'play',
            eventData
        });
        this.state.play = true;
    }
    onPlaying(eventData) {
        if (!this.state.play) {
            this.onPlay(eventData);
        }
        this.state.hasStartedPlaying = true;
    }
    onSeeked(eventData) {
        this.state.seeking = false;
    }
    onSeeking(eventData) {
        let { amp } = eventData;
        if (amp.playState != "ready") {
            this.track({
                mmodule: `${this.moduleName}-ctl`,
                mlink: 'scrb',
                eventData
            })
        }
        this.state.seeking = true;
    }
    onStarted(eventData) {
        this.state.started = true;
        this.state.loadeddata = false;
        const contextData = this.settings.monetizedMedia === true ? {
            "wb.engmt": 1
        } : {};

        if (this.state.ended) {
            this.track({
                mmodule: `${this.moduleName}-ctl`,
                mlink: 'rep',
                eventData
            })
        }
        this.track({
            mmodule: `${this.moduleName}`,
            mlink: 'start',
            eventData,
            contextData
        });
        this.resetMilestones();
        this.state.ended = false;
    }
    onTimeupdate(eventData) {
        // BUGFIX: AUDIO PLAYER DOESN'T ALWAYS TRIGGER THE START EVENT
        if(this.state.started == false) {
            this.onPlay(eventData);
        }
        let { timePercent } = eventData.state;
        this.trackMilestone(timePercent, eventData)
    }
    onMutechange(eventData) {
        let { state } = eventData;
        debug.log("[OmnitureTracking] Mutechange", eventData, "\nstate:", state);
        debug.log("[OmnitureTracking] Mutechange allowTracking:",this.state.allowTracking);
        if (this.state.loadeddata && !this.state.hasStartedPlaying) {
            return;
        } else if (this.state.started && !this.state.loadeddata) {
            return;
        } else if (this.state.muted != state.isMuted) {
            this.state.muted = state.isMuted;
            const mlink = state.isMuted ? 'mute' : 'unmute';
            this.track({
                mmodule: `${this.moduleName}-ctl`,
                mlink: mlink,
                eventData
            },true)
        }

    }
    onVolumechange(eventData) {

        let { state } = eventData;
        debug.log("[OmnitureTracking] Volumechange", eventData, "\nstate:", state);
        if (this.state.loadeddata && !this.state.hasStartedPlaying) {
            return;
        } else if (this.state.started && !this.state.loadeddata) {
            return;
        } else if (Number.isNaN(state.duration) === false && state.duration > 0) {
            const mlink = "vol";
            //debug.log("[Omniture Tracking] onVolumechange - track called", state.duration);
            this.track({
                mmodule: `${this.moduleName}-ctl`,
                mlink: mlink,
                eventData
            },true)
        }

    }
    startTracking() {
        this.state.allowTracking = true;
        debug.log("[OmnitureTracking] Start Tracking");
    }
    stopTracking() {
        this.state.allowTracking = false;
        debug.log("[OmnitureTracking] Stop Tracking");
    }

    resetMilestones() {
        let { milestones } = this;
        let percentages = Object.keys(milestones);
        percentages.forEach(percent => {
            milestones[percent] = true;
        });
    }
    trackMilestone(timePercent = 0, eventData) {

        let percentages = Object.keys(this.milestones);
        percentages.forEach(percent => {
            if (timePercent >= parseInt(percent) && this.milestones[percent] == true) {
                this.milestones[percent] = false;
                this.track({
                    mmodule: this.moduleName,
                    mlink: `${percent}pct`,
                    eventData
                }, true);
            }
        })
    }
    track(data, forceTracking = false) {
        const { state } = this;
        if (forceTracking || state.allowTracking) {

            const { s_gi, s_account, wmdSetContext, addLinkTrackVars, wmdRemContext, wmdPageLink, remLinkTrackVars } = window;
            const s_md = s_gi(s_account);
            const { NEW_CONTEXT_VARS, videoTrackingObject } = this;
            //debug.log("[Omniture Tracking] videoTrackingObject:", this.videoTrackingObject);
            const vtKeys = Object.keys(videoTrackingObject);
            vtKeys.forEach(
                (key) => { wmdSetContext(key, videoTrackingObject[key]); }
            );

            

            const { mmodule, mlink, contextData } = data;
            const pageLinkCode = `${mmodule}_${mlink}`;
            const _linkTrackVars = s_md.linkTrackVars.split(",");
            const newLinkTrackVars = NEW_CONTEXT_VARS.filter(linkTrackVar => {
                return _linkTrackVars.includes(linkTrackVar) == false;
            });

            const cdKeys = contextData != null ? Object.keys(contextData) : [];
            cdKeys.forEach( key => {
                newLinkTrackVars.push(key);
                wmdSetContext(key, contextData[key]);
                
            })
            

            addLinkTrackVars(newLinkTrackVars);
            //debug.log("[Omniture Tracking] New Link Track Vars:", newLinkTrackVars);
            //debug.log("[Omniture Tracking] New Link Track Vars:", s_md.linkTrackVars.toString());
            //debug.log("[Omniture Tracking] New Link Track Vars:", JSON.stringify(s_md.contextData));
            try {
                debug.log(`%c[OmnitureTracking] Track: %c${pageLinkCode}`, "font-weight: bold;", "color: #0cc;");
                wmdPageLink(pageLinkCode);
            } finally {
                vtKeys.forEach( key => { 
                    wmdRemContext(key) 
                });
                cdKeys.forEach( key => {
                    wmdRemContext(key);
                });
                remLinkTrackVars(newLinkTrackVars.join(","));
            }
        }
    }
}